import React, { memo } from "react";
import {
  Form,
  Grid 
} from "semantic-ui-react";
import InputField from "./inputField";
import { Country } from "../dropdown/country";
import DropDown from "./dropDown";
import { TranslateContext } from "../../NL_App/formSections/TranslateContext";
import { AddBtn } from "../AddBtn";

 const ActorDetailForm = ({
  actorName,
  actorLabel,
  actorType,
  disabled,
  displayContactInfo,
  displayREP,
  displayEoriNo,
  dataSource,
  repvalidationMsg,
  invoiceId="",
  boxNumber,
  errorInfo,
  disableFields={},
  representations,CountryList,saveActorDetails,updateActorFieldValue,updateActorContactInfo,saveActorContactDetails,
  showPopUp=false,
  copyFeature={},
  repKey="representation",
  eoriKey="eoriNo",
  countryKey = "country",
  address2='addressLine2',
   firstRowFields
 }) => {
  
  const {
    postalCode,
    name,
    contact = {},
    addressLine1,
    [`${address2}`]: addressLine2,
    city,
    state,
    id,
    [`${repKey}`]: representation,
    [`${eoriKey}`]: eoriNo,
    [`${countryKey}`]: country,
    privateIndicatorFlag,
  } = dataSource
  const {name:Name,email,phone}=contact
  const translate = React.useContext(TranslateContext).translate
  if(!id)
  return <AddBtn 
  id={`${actorType}Add`} 
  onClick={()=> {
    if(showPopUp){
      if (!window.confirm(`Are you sure you want to add exporter to Invoice? This would copy Parties' tab exporter data to all the invoices and also replace the existing parties' tab exporter with dummy data : 00200`))
      return
    }
    saveActorDetails({ name:' ', id, actorType })
  }
  }
   text='Add'>

  </AddBtn>
  let extraFields = firstRowFields && firstRowFields({updateActorFieldValue,saveActorDetails,id,actorType,translate,privateIndicatorFlag,disabled,disableFields,errorInfo})
  return (
    <Form.Group className='float-container'>
      {actorLabel && <span>{translate(actorLabel, { ns: ['default', 'parties'] })}</span>}
      <Grid columns='3'>
        <Grid.Row width='equals'>
          <Grid.Column
            width={!displayEoriNo ? '16' : '9'}
            className={`divFormFeild ${displayEoriNo ? 'b-rw-0' : 'b-trr-5'} b-tlr-5`}
          >
            <InputField
              isLabel={false}
              id={`${actorType}FullName${invoiceId}`}
              type='text'
              label={translate(actorName, { ns: ['default', 'parties'] })}
              boxNumber={boxNumber?.name}
              className='b-rw-0'
              errors={errorInfo?.name}
              value={name || ''}
              clearInput={false}
              onChange={(value) => updateActorFieldValue(actorType, { name: value })}
              onBlur={(value) => saveActorDetails({ name: name || ' ', id, actorType }, 'name')}
              disabled={disabled || disableFields?.name}
            />
          </Grid.Column>
          {displayEoriNo && (
            <Grid.Column
              width={!(displayREP || extraFields) ? '7' : '4'}
              className={`divFormFeild ${!(displayREP || extraFields) ? 'b-trr-5' : 'b-rw-0'}`}
            >
              <InputField
                isLabel={false}
                id={`${actorType}eoriNumber${invoiceId}`}
                errors={!disabled && errorInfo?.[eoriKey]}
                type='text'
                label={translate('EORI_NUMBER', { ns: ['default', 'parties'] })}
                boxNumber={boxNumber?.eoriNo}
                value={eoriNo || ''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) =>
                  updateActorFieldValue(actorType, { [`${eoriKey}`]: value.toUpperCase() })
                }
                onBlur={(value) =>
                  saveActorDetails({ [`${eoriKey}`]: eoriNo || ' ', id, actorType }, eoriKey)
                }
                disabled={disabled || disableFields?.eoriNo}
                copyToFeature={copyFeature.eoriNo}
              />
            </Grid.Column>
          )}
          {displayREP && (
            <Grid.Column width='3' className='divFormFeild b-trr-5'>
              <DropDown
                id={`${actorType}Rep${invoiceId}`}
                label={
                  <React.Fragment>
                    {repvalidationMsg && repvalidationMsg}
                    {translate('REP', { ns: ['default', 'parties'] })}
                  </React.Fragment>
                }
                boxNumber={boxNumber?.rep}
                disabled={disabled || disableFields?.rep}
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                data={representations}
                value={representation}
                direction='left'
                onChange={(value) => updateActorFieldValue(actorType, { [`${repKey}`]: value })}
                onBlur={(value) =>
                  saveActorDetails({ [`${repKey}`]: representation || ' ', id, actorType }, repKey)
                }
              />
            </Grid.Column>
          )}
          {extraFields}
        </Grid.Row>

        <Grid.Row className={`addressField ${!displayContactInfo ? 'b-bw-1 b-br-5' : ''}`}>
          <label className='name-label es'>
            {translate('ADDRESS', { ns: ['default', 'parties'] })}
          </label>

          <Grid.Column width='3' className='first-column'>
            <InputField
              isLabel={false}
              isFooterLabel={true}
              id={`${actorType}AddressLine1${invoiceId}`}
              type='text'
              value={addressLine1 || ''}
              errors={!disabled && errorInfo?.addressLine1}
              label={translate('ADDRESS_LINE_1', { ns: ['default', 'parties'] })}
              clearInput={false}
              onChange={(value) => updateActorFieldValue(actorType, { addressLine1: value })}
              onBlur={(value) => {
                const [streetNumber, ...streetName] = addressLine1?.split(' ') || []
                const streetNames = streetName.join(' ')
                saveActorDetails(
                  {
                    streetName: streetNames || ' ',
                    streetNumber: streetNumber || ' ',
                    id,
                    actorType,
                  },
                  'addressLine1'
                )
              }}
              disabled={disabled || disableFields?.addressLine1}
            />
          </Grid.Column>
          <Grid.Column width='3'>
            <InputField
              isLabel={false}
              isFooterLabel={true}
              id={`${actorType}AddressLine2${invoiceId}`}
              type='text'
              label={translate('ADDRESS_LINE_2', { ns: ['default', 'parties'] })}
              className={'field-bg'}
              clearInput={false}
              errors={!disabled && errorInfo?.[address2]}
              value={addressLine2 || ''}
              onChange={(value) => updateActorFieldValue(actorType, { [`${address2}`]: value })}
              onBlur={(value) =>
                saveActorDetails({ [`${address2}`]: addressLine2 || ' ', id, actorType }, address2)
              }
              disabled={disabled || disableFields?.addressLine2}
            />
          </Grid.Column>
          <Grid.Column width='3'>
            <InputField
              isLabel={false}
              isFooterLabel={true}
              id={`${actorType}City${invoiceId}`}
              type='text'
              label={translate('CITY', { ns: ['default', 'parties'] })}
              errors={!disabled && errorInfo?.city}
              value={city || ''}
              className='field-bg'
              clearInput={false}
              onChange={(value) => updateActorFieldValue(actorType, { city: value })}
              onBlur={(value) => saveActorDetails({ city: city || ' ', id, actorType }, 'city')}
              disabled={disabled || disableFields?.city}
            />
          </Grid.Column>
          <Grid.Column width='2'>
            <InputField
              isLabel={false}
              isFooterLabel={true}
              id={`${actorType}state${invoiceId}`}
              errors={!disabled && errorInfo?.state}
              type='text'
              label={translate('STATE_PROVINCE', { ns: ['default', 'parties'] })}
              value={state || ''}
              className='field-bg'
              clearInput={false}
              onChange={(value) => updateActorFieldValue(actorType, { state: value })}
              onBlur={(value) => saveActorDetails({ state: state || ' ', id, actorType }, 'state')}
              disabled={disabled || disableFields?.state}
            />
          </Grid.Column>
          <Grid.Column width='3'>
            <InputField
              isLabel={false}
              isFooterLabel={true}
              id={`${actorType}ZipCode${invoiceId}`}
              type='text'
              value={postalCode || ''}
              label={translate('ZIP', { ns: ['default', 'parties'] })}
              className={'field-bg'}
              clearInput={false}
              errors={!disabled && errorInfo?.postalCode}
              onChange={(value) => updateActorFieldValue(actorType, { postalCode: value })}
              onBlur={(value) =>
                saveActorDetails({ postalCode: postalCode || ' ', id, actorType }, 'postalCode')
              }
              disabled={disabled || disableFields?.postalCode}
            />
          </Grid.Column>
          <Grid.Column width='2' className='dropdownCarrotPosition'>
            <Country
              id={`${actorType}Country${invoiceId}`}
              label={translate('COUNTRY', { ns: ['default', 'parties'] })}
              disabled={disabled || disableFields?.country}
              direction='left'
              dataSource={CountryList}
              errors={!disabled && errorInfo?.[countryKey]}
              value={country}
              isFooterLabel={true}
              clearable
              onChange={(value) => {
                updateActorFieldValue(actorType, { [`${countryKey}`]: value.toUpperCase() })
                saveActorDetails({ [`${countryKey}`]: value || ' ', id, actorType }, countryKey)
              }}
            />
          </Grid.Column>
        </Grid.Row>

        {displayContactInfo && (
          <Grid.Row>
            <Grid.Column width='5' className='divFormFeild b-rw-0 border-bottom b-blr-5'>
              <InputField
                isLabel={false}
                id={`${actorType}ContactName${invoiceId}`}
                type='text'
                label={translate('CONTACT_NAME', { ns: ['default', 'parties'] })}
                className='b-rw-0'
                value={Name || ''}
                clearInput={false}
                onChange={(value) => updateActorContactInfo(actorType, { name: value })}
                onBlur={(value) => saveActorContactDetails(actorType, { name: Name || ' '}, id)}
                disabled={disabled}
              />
            </Grid.Column>

            <Grid.Column width='6' className='divFormFeild border-bottom b-rw-0 '>
              <InputField
                isLabel={false}
                id={`${actorType}ContactEmail${invoiceId}`}
                type='text'
                label={translate('CONTACT_EMAIL', { ns: ['default', 'parties'] })}
                value={email || ''}
                className={'field-bg'}
                clearInput={false}
                onChange={(value) => updateActorContactInfo(actorType, { email: value })}
                onBlur={(value) => saveActorContactDetails(actorType, { email : email || ' ' }, id)}
                disabled={disabled}
              />
            </Grid.Column>

            <Grid.Column width='5' className='divFormFeild border-bottom b-brr-5'>
              <InputField
                isLabel={false}
                id={`${actorType}ContactPhone${invoiceId}`}
                type='text'
                label={translate('CONTACT_PHONE', { ns: ['default', 'parties'] })}
                value={phone || ''}
                className='field-bg'
                clearInput={false}
                onChange={(value) => updateActorContactInfo(actorType, { phone: value })}
                onBlur={(value) => saveActorContactDetails(actorType, { phone:phone || ' ' }, id)}
                disabled={disabled}
              />
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </Form.Group>
  )
  
}


ActorDetailForm.defaultProps={
  displayContactInfo:false,
  displayREP:false,
  displayEoriNo:true
}
export default memo(ActorDetailForm)




//  boxNumber = {name:'3/1', eoriNo:'3/2', rep:'3/3'}